import { Component, output } from '@angular/core';
import { faClose } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'empathy-selected-value-view',
  templateUrl: './selected-value-view.component.html',
  styleUrls: ['./selected-value-view.component.scss']
})
export class SelectedValueViewComponent {
  onClear = output<void>();

  faClose = faClose;
}
